const formatter = new Intl.NumberFormat('ru', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatPayment = (payment: number): string => {
  return `от ${formatter.format(payment)} ₽/мес`;
};
